import { Modal } from 'antd';

type BVProductsConfirmDeleteModalProps = {
	open: boolean;
	title?: string;
	content: string;
	confirmText?: string;
	cancelText?: string;
	loading?: boolean;
	onConfirm: () => void | Promise<void>;
	onCancel: () => void;
};

const BVProductsConfirmDeleteModal = ({
	open,
	title = 'Confirm destructive operation',
	content,
	confirmText = 'Yes, continue',
	cancelText = 'Cancel',
	loading = false,
	onConfirm,
	onCancel,
}: BVProductsConfirmDeleteModalProps) => {
	return (
		<Modal
			visible={open}
			title={title}
			okText={confirmText}
			cancelText={cancelText}
			okButtonProps={{ danger: true, loading }}
			onOk={onConfirm}
			onCancel={onCancel}
			destroyOnClose
		>
			{content}
		</Modal>
	);
};

export default BVProductsConfirmDeleteModal;
